export const TagDragDataFormat = 'application/x-sn-drag-tag';
export const NoteDragDataFormat = 'application/x-sn-drag-note';
